var _defs, _rect, _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _circle5, _circle6, _text, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAiCustomerServiceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 280",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E8EDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5FCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "core",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5D7F9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#03363D"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 280,
    rx: 12,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 90,
    r: 10,
    fill: "#4A6984",
    opacity: 0.35
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 85,
    r: 8,
    fill: "#17494D",
    opacity: 0.35
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 175,
    r: 7,
    fill: "#4A6984",
    opacity: 0.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 180,
    r: 9,
    fill: "#17494D",
    opacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 90 L175 115 M280 85 L225 115 M95 175 L175 145 M305 180 L225 145",
    stroke: "#4A6984",
    strokeWidth: 1.5,
    opacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68 130 L72 138 L80 140 L72 142 L68 150 L64 142 L56 140 L64 138 Z",
    fill: "#5D7F9A",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M328 120 L331 126 L337 128 L331 130 L328 136 L325 130 L319 128 L325 126 Z",
    fill: "#5D7F9A",
    opacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200 48 L203 54 L209 56 L203 58 L200 64 L197 58 L191 56 L197 54 Z",
    fill: "#17494D",
    opacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 132,
    r: 58,
    fill: "url(#core)",
    opacity: 0.12
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 132,
    r: 48,
    fill: "url(#core)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 142,
    textAnchor: "middle",
    fill: "#FFFFFF",
    fontFamily: "Inter,Segoe UI,sans-serif",
    fontSize: 32,
    fontWeight: 700
  }, "AI")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 168,
    width: 72,
    height: 36,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#4A6984",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 180,
    width: 36,
    height: 6,
    rx: 3,
    fill: "#DAEDED"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 192,
    width: 48,
    height: 5,
    rx: 2.5,
    fill: "#E9EBED"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 168,
    width: 56,
    height: 28,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#DAEDED",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 178,
    width: 32,
    height: 5,
    rx: 2.5,
    fill: "#E8EDF2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 188,
    width: 24,
    height: 4,
    rx: 2,
    fill: "#E9EBED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiCustomerServiceIcon);
export default __webpack_public_path__ + "static/media/ai-customer-service-icon.633ea63ccd47fc7293b7a6eadfc53bd5.svg";
export { ForwardRef as ReactComponent };